import React, { useState, useEffect } from "react";
import { PiSpeakerSimpleNone } from "react-icons/pi";
import { PiSpeakerHigh } from "react-icons/pi";

import { useSpeechSynthesis } from "react-speech-kit";

const Volumeon=()=>{
  return(
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2083_36908)">
<path d="M10.1113 4.77734L5.66688 8.3329H2.11133V13.6662H5.66688L10.1113 17.2218V4.77734Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.7782 8.33301L15.4448 13.6663" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.4448 8.33301L20.7782 13.6663" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_2083_36908">
<rect width="21.3333" height="21.3333" fill="white" transform="translate(0.333496 0.333008)"/>
</clipPath>
</defs>
</svg>

  )
}
const Volumeoff=()=>{
return(
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.1113 4.7793L5.66688 8.33485H2.11133V13.6682H5.66688L10.1113 17.2237V4.7793Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.2848 4.7168C18.9512 6.38371 19.8873 8.64423 19.8873 11.0012C19.8873 13.3583 18.9512 15.6188 17.2848 17.2857M14.147 7.85457C14.9802 8.68803 15.4482 9.81829 15.4482 10.9968C15.4482 12.1753 14.9802 13.3056 14.147 14.139" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

)
}
const TextToSpeech = ({ text }) => {
  
  const [play, setPlay] = useState(false);
  const onEnd = () => {
    setPlay(false);
    document.getElementById("wave-microphone").style.display = "none";
  };
  const { speak,cancel } = useSpeechSynthesis({ onEnd });

  

  const handlePlay = () => {
    const voices = window.speechSynthesis.getVoices();
    document.getElementById("wave-microphone").style.display = "flex";
    console.log(voices);
    let voice
    let rate
    

   voice = voices.find(
      (voice) => voice.name === "Microsoft Heera - English (India)"
    );

 
  
    rate= 1.9;
    if (!voice) {
      voice = voices.find((voice) => voice.name === "Samantha");
      rate = 1;
    }
  
    console.log(voice);
    speak({ text: text, voice: voice, rate: rate });
    setPlay(true);
  };
  const handlePause = () => {
    // Pause speaking
    cancel();
    setPlay(false);
    document.getElementById("wave-microphone").style.display = "none";
  };
  return (

    <div className="border-[#444D63] bg-[#444D63E5] border-2 text-white rounded-full grid place-content-center text-xl p-3">
      {play ? (
        <button onClick={handlePause}>
      <Volumeon className="w-[90%]"/>
        </button>
      ) : (
        <button onClick={handlePlay}>
         <Volumeoff className="w-[90%]"/>
        </button>
      )}
    </div>
  );
};

export default TextToSpeech;
